import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, formatTL } from "@/lib/api";

const show = (r, v) => (r.field === "aylik_brut" || r.field === "yemek_gunluk" ? (v == null ? "Pozisyon varsayılanı" : formatTL(v)) : r.field === "maas_tipi" ? (v === "net" ? "Net" : "Brüt") : v || "—");

export const FieldHistory = ({ personnelId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/personnel/${personnelId}/field-history`).then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, [personnelId]);
  if (!rows) return null;
  return (
    <div className="border border-slate-200 rounded-lg p-3 bg-slate-50" data-testid="personnel-field-history">
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1 mb-2">
        <History size={12} /> Maaş / IBAN / Yemek Değişiklik Geçmişi
      </div>
      {rows.length === 0 ? (
        <div className="text-xs text-slate-400">Henüz değişiklik yok</div>
      ) : (
        <div className="max-h-36 overflow-y-auto space-y-1">
          {rows.map((r) => (
            <div key={r.id} className="text-xs text-slate-700 flex flex-wrap gap-x-2" data-testid={`field-history-${r.id}`}>
              <span className="font-mono text-slate-500">{new Date(r.changed_at).toLocaleString("tr-TR")}</span>
              <span className="font-semibold">{r.field_label}:</span>
              <span className="line-through text-rose-600">{show(r, r.old)}</span>→
              <span className="text-emerald-700 font-semibold">{show(r, r.new)}</span>
              <span className="text-slate-400">· {r.changed_by_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
